/**
 * @generated SignedSource<<92f7ad323f782eee353e780572d3b74b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ruleConflictDialog_PreviewQuery$variables = {
  matchKind?: string | null | undefined;
  regex?: string | null | undefined;
  ruleId: string;
};
export type ruleConflictDialog_PreviewQuery$data = {
  readonly ruleDeltaPreview: {
    readonly capturedCount: number;
    readonly droppedCount: number;
    readonly truncated: boolean;
  };
};
export type ruleConflictDialog_PreviewQuery = {
  response: ruleConflictDialog_PreviewQuery$data;
  variables: ruleConflictDialog_PreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "matchKind"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regex"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "matchKind",
    "variableName": "matchKind"
  },
  {
    "kind": "Variable",
    "name": "regex",
    "variableName": "regex"
  },
  {
    "kind": "Variable",
    "name": "ruleId",
    "variableName": "ruleId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "capturedCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "droppedCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "truncated",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleConflictDialog_PreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RuleDelta",
        "kind": "LinkedField",
        "name": "ruleDeltaPreview",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ruleConflictDialog_PreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "RuleDelta",
        "kind": "LinkedField",
        "name": "ruleDeltaPreview",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c47e776b1b35752d1f5024cc0a425a1",
    "id": null,
    "metadata": {},
    "name": "ruleConflictDialog_PreviewQuery",
    "operationKind": "query",
    "text": "query ruleConflictDialog_PreviewQuery(\n  $ruleId: ID!\n  $regex: String\n  $matchKind: String\n) {\n  ruleDeltaPreview(ruleId: $ruleId, regex: $regex, matchKind: $matchKind) {\n    capturedCount\n    droppedCount\n    truncated\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f37b482d905453be488f6bd3d188162";

export default node;
